import request from '../service';

const prefix = 'operation/';

// 获取统计数据
interface SumParams {
  deviceId?: string | null;
  sdate?: string;
  edate?: string;
  groupId?: string | null;
  key?: string | null;
  projectId: string | null;
}
export const fetchSum = (params: SumParams) => {
  return request.get(
      prefix + 'v1/visit/record/total',
      {
        params,
      },
  ).then(res => res.data);
};

// 分页查询访客记录
interface VisitorsParams extends SumParams {
  pageNo: string | number;
  pageSize: string | number;
  status?: any;
}
export const fetchVisitors = (params: VisitorsParams) => {
  return request.get(
    prefix + 'v1/visit/record/page',
    {
      params,
    },
  ).then(res => res.data);
};

// 查询机器人列表
interface RobotListParams {
  faceGroupId?: string | null;
  projectId: string | null;
}
export const fetchRobotList = (params: RobotListParams) => {
  return request.get(
    prefix + 'v1/visit/devices',
    {
      params,
    },
  ).then(res => res.data);
};

// 查询机器人列表
interface FaceGroupParams {
  projectId: string | null;
}
export const fetchFaceGroupList = (params: FaceGroupParams) => {
  return request.get(
    prefix + 'v1/visit/faceGroups',
    {
      params,
    },
  ).then(res => res.data);
};

// 获取设备关联人脸库列表
interface FaceGroupOptionParams {
  deviceId: string;
  projectId: string | null;
}
export const fetchDeviceFaceGroupOptions = (params: FaceGroupOptionParams) => {
  return request.get(
    prefix + 'v1/visit/device/faceGroups',
    {
      params,
    },
  ).then(res => res.data);
};

// 记录人脸录入失败
interface FaceFailRecodParams {
  errorMsg: string;
  recordId: number | string;
}
export const setFailRecord = (data: FaceFailRecodParams) => {
  return request.put(
    prefix + 'v1/visit/record/error',
    data,
  ).then(res => res.data);
};

// 人脸略缩图
export const thumbAvatarUrl = (path: string) => {
  return request.defaults.baseURL + prefix + 'v1/visit/thumb/pic?path=' + path;
};

// 人脸大图
export const avatarUrl = (path: string) => {
  return request.defaults.baseURL + prefix + 'v1/visit/pic?path=' + path;
};

// 人脸库和访客记录绑定
interface FaceLibBindingParams {
  faceId: string;
  id: number | string;
}
export const bindFaceLibWithVisitorRecord = (data: FaceLibBindingParams) => {
  return request.put(
    prefix + 'v1/visit/record/addToGroup',
    data,
  ).then(res => res.data);
};

export default {
  fetchSum,
  fetchVisitors,
  fetchRobotList,
  fetchFaceGroupList,
  thumbAvatarUrl,
  avatarUrl,
  fetchDeviceFaceGroupOptions,
  setFailRecord,
  bindFaceLibWithVisitorRecord,
};
